var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
  {
    required: _vm.context.rules.find( function (rule) { return rule.ruleName === 'required'; })
  },
  _vm.context.classes.label ],attrs:{"for":_vm.context.id}},[_vm._v(" "+_vm._s(_vm.context.label)+" "),_c('span',{staticClass:"material-icons-outlined"})])}
var staticRenderFns = []

export { render, staticRenderFns }